import type { MyScoreFragment } from '~/client/features/Tournaments/graphql/TournamentFragment.generated';
import LeaderboardItem from '../LeaderboardItem';

type Props = {
  myScore?: MyScoreFragment;
};

const DefaultLeaderboard: React.FC<Props> = ({ myScore }) => {
  const { leaderboardBefore, leaderboardAfter } = myScore || {};
  const isLast = !leaderboardAfter?.length;

  return (
    <>
      {isLast && (
        <LeaderboardItem
          username={leaderboardBefore?.[1]?.username}
          points={leaderboardBefore?.[1]?.points}
          position={leaderboardBefore?.[1]?.position ?? 1}
        />
      )}
      <LeaderboardItem
        username={leaderboardBefore?.[2]?.username}
        points={leaderboardBefore?.[2]?.points}
        position={leaderboardBefore?.[2]?.position ?? 2}
      />
      <LeaderboardItem
        username={myScore?.username}
        points={myScore?.points}
        position={myScore?.position ?? 3}
        isMyScore={myScore?.isMyScore}
      />
      {!!leaderboardAfter?.length && (
        <LeaderboardItem
          username={leaderboardAfter?.[0]?.username}
          points={leaderboardAfter?.[0]?.points}
          position={leaderboardAfter?.[0]?.position}
        />
      )}
    </>
  );
};

export default DefaultLeaderboard;
